import ReactDOM from "react-dom";

import App from "./App";
require("./index.css")

ReactDOM.render(<App />, document.getElementById("root"));
